import React, { useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { respuestasContext } from '../contexts/RespuestasContext'


//COMPONENTES HIJOS
import { OfertasBebesCmp } from '../components/bebes/OfertasBebesCmp1'
import { LocalizacionCmp } from '../components/LocalizacionCmp'
import { MesCmp } from '../components/MesCmp'
import { KidNameCmp } from '../components/kids/KidNameCmp'
import { KidAgeCmp } from '../components/kids/KidAgeCmp'
import { PhoneNumberCmp } from '../components/PhoneNumberCmp'
import { TermsCmp } from '../components/TermsCmp'
import { TipopagoCmp } from '../components/TipopagoCmp'
import { DudaCmp } from '../components/DudaCmp'
import { ThanksCmp } from '../components/ThanksCmp'



function BebesPage({ ofertasbebes }) {
    const navigate = useNavigate();
    const { respuestas, setRespuestas, addtoanswers } = useContext(respuestasContext);
    //const [respuestas, setRespuestas] = useState({})
    const [children, setChildren] = useState(<OfertasBebesCmp ofertasbebes={ofertasbebes} addOferta={addOferta} />)
    const [agregada, setAgregada] = useState(false)


    


    function addOferta(oferta) {
        addtoanswers(oferta)
        //setChildren(<LocalizacionCmp addLocalizacion={addLocalizacion} />)
        setChildren(<MesCmp addMes={addMes} />)
    }

    // function addLocalizacion(localizacion) {
    //     addtoanswers(localizacion)
    //     setChildren(<MesCmp addMes={addMes} />)
    // }

    function addMes(mes) {
        const objetomes = { mes: mes };
        addtoanswers(objetomes)
        setChildren(<KidNameCmp addKidName={addKidName} />)
    }


    function addKidName(kidname) {
        const objetokid = { nombrekid: kidname };
        addtoanswers(objetokid)
        setChildren(<KidAgeCmp addKidage={addKidage} />)
    }

    function addKidage(kidage) {
        const objetokid = { edad: kidage };
        addtoanswers(objetokid)
        setChildren(<PhoneNumberCmp addPhonenumber={addPhonenumber} />)

    }


    function addPhonenumber(phonenumber) {
        const phone = { phonenumber: phonenumber };
        addtoanswers(phone)
        setChildren(<TermsCmp addTerms={addTerms} />)
        // alert("SITIO EN CONSTRUCCION SEE YOU SOON")
        // navigate("/");
    }


    function addTerms(acepto) {
        acepto ? setChildren(<TipopagoCmp addTipopago={addTipopago} />) : noaceptolosterminos();
    }

    function noaceptolosterminos() {
        alert("DEBE ACEPTAR LOS TERMINOS PARA CONTINUAR AGENDANDO")
        setRespuestas({})
        navigate("/");
    }

    function addTipopago(tipopago) {
        addtoanswers(tipopago)
        setChildren(<DudaCmp addDuda={addDuda} />)
    }


    async function addDuda (duda) {
        const objetduda = { duda: duda };
        const done = await addtoanswers(objetduda)
        if (done) {
            resetForm();
            setAgregada(true)
            setTimeout(() => {
                setAgregada(false);
            }, 1600);
            setChildren(<ThanksCmp />)
        }
    }

    function resetForm() {
        setRespuestas({})
    }

    return (
        <div className="hero min-h-screen bg-base-200" style={{ backgroundColor: 'lightcoral' }}>
             {agregada ? (<div role="alert" className="alert alert-success" style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', zIndex: 1000 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-10 w-10" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    <h2 className="text-2xl">Su respuesta se a enviado con éxito!</h2>
                </div>) : null}
            <div className="hero-content text-center">
                <div className="max-w-md">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default BebesPage



// function addOferta(oferta) {
//     addtoanswers(oferta)
//     setChildren(<LocalizacionCmp addLocalizacion={addLocalizacion} />)
// }

// function addLocalizacion(localizacion) {
//     addtoanswers(localizacion)
//     setChildren(<MesCmp addMes={addMes} />)
// }
